import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router';
import { SetComponentLanguage, ApiRequest } from './helpers';
import { Ably, Realtime } from 'ably';
import axios from 'axios';
import moment from 'moment';
import countdown from 'moment-countdown';
import URLSearchParams from '@ungap/url-search-params'
import LocalizedStrings from 'react-localization';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Navigation from './components/Navigation/Navigation';
import EventListing from './components/EventListing/EventListing';
import Registration from './components/Registration/Registration';
import Login from './components/Login/Login';
import FAQ from './components/FAQ/FAQ';
import ReprintOrder from './components/ReprintOrder/ReprintOrder';
import Checkin from './components/Checkin/Checkin';
import Search from './components/Search/Search';
import SearchEvents from './components/SearchEvents/SearchEvents';
import ClientPreferences from './components/ClientPreferences/ClientPreferences';
import CreateUser from './components/CreateUser/CreateUser';
import CreateEvent from './components/CreateEvent/CreateEvent';
import CreateCustomer from './components/CreateCustomer/CreateCustomer';
import ManageCoupon from './components/ManageCoupon/ManageCoupon';
import CreateCoupon from './components/CreateCoupon/CreateCoupon';
import CreateFlexpass from './components/CreateFlexpass/CreateFlexpass';
import SavePublishEvent from './components/SavePublishEvent/SavePublishEvent';
import ClientAgreement from './components/ClientAgreement/ClientAgreement';
import UserAgreement from './components/UserAgreement/UserAgreement';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import Page404 from './components/Common/Page404/Page404';
import Forbidden from './components/Common/Forbidden/Forbidden';
import Message from './components/Common/Message/Message';
import ForgotUsername from './components/ForgotUsername/ForgotUsername';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import ResetPassword from './components/ResetPassword/ResetPassword';
import NewUserLogin from './components/NewUserLogin/NewUserLogin';
import TicketDownload from './components/TicketDownload/TicketDownload';
import Videos from './components/Videos/Videos';
import EventLanding from './components/EventLanding/EventLanding';
import Stream from './components/Stream/Stream';
import StreamLaunch from './components/StreamLaunch/StreamLaunch';
import StreamDemo from './components/StreamDemo/StreamDemo';
import StreamUpdates from './components/StreamUpdates/StreamUpdates';
import Upload from './components/Upload/Upload';
import Billing from './components/Client/Billing/Billing';
import Options from './components/Client/Options/Options';
import Marketing from './components/Client/Marketing/Marketing';
import Users from './components/Client/Users/Users';
import Stripe from './components/Client/Stripe/Stripe';
import Payout from './components/Payout/Payout';
import ClaimsCopyright from './components/ClaimsCopyright/ClaimsCopyright';
import OnboardComplete from './components/OnboardComplete/OnboardComplete';
import Accessibility from './components/Accessibility/Accessibility';
import AccountBalance from './components/AccountBalance/AccountBalance';
import ElectronicTicket from './components/ElectronicTicket/ElectronicTicket';
import TicketDistribution from './components/TicketDistribution/TicketDistribution';
import GetToken from './components/GetToken/GetToken';
import Unsubscribe from './components/Unsubscribe/Unsubscribe';
import Status from './components/Status/Status';
import ClientTrackingTool from './components/Common/ClientTrackingTool/ClientTrackingTool';
import Star from './components/Client/Star/Star';
import StripePayment from './components/Stripe/Stripe';
import en from './locales/en.json';
import fr from './locales/fr.json';

import './App.css';

window.general_strings = SetComponentLanguage(LocalizedStrings, en, fr);
window.Ably = new Realtime(process.env.REACT_APP_ABLY_API_KEY);
var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isNavigationOpen: false,
			isCartOpen: false,
			isReprintOrderOpen: false,
			isSavePublishEventOpen: false,
            saveEventMode: '',
            totalItemsInCart: 0,
            isEventDraftButtonHidden: false,
            client: {},
			clients: [],
			user: {},
			real_user: {
				role: '',
			},
            isLoggedinUser: false,
            isDonation: false,
            isGodMode: false,
			message: {
                title: '',
                content: '',
                type: ''
            },
			timer: null,
			isUpdateClient: false,
			isReservedSeatingNew: false,
			// coupon
            showSaveCouponBtn: false,
            saveCouponMode: false,
            couponExists: false,
			// flexpass
            saveFlexpassMode: false,
            flexpassExists: false,
			userStatusReady: false,
			// go to search direct after login
			goToDailyEmailSearch: false,
            transaction_end: undefined,
            transaction_start: undefined,
			// stream
			streamEvent: {},
			streamConfig: {},
			isStreamDescriptionModalOpen: false,
			isStreamArtistsModalOpen: false,
			isChatOpen: false,
			status: {
				maintenance: {
					active: [],
					upcoming: [],
				},
				incidents: [],
				status: [],
				status_overall: {},
			},
		}
	}

	toggleEventDraftButton = (value) => {
		this.setState({
			isEventDraftButtonHidden: value
		});
	}

	toggleSavePublishButton = (value) => {
		this.setState({
			isReservedSeatingNew: value
		});
	}

	/* Coupon */
    toggleSaveCouponButton = (value) => {
        this.setState({
            showSaveCouponBtn: value
        });
    }

    enableSaveCouponButton = (value) => {
        this.setState({
            isReadyToSubmitCoupon: value
        });
    }

    toggleCouponExists = (value) => {
        this.setState({
            couponExists: value
        });
    }

    saveUpdateCouponEvent = (value) => {
        this.setState({
            saveCouponMode: value
        });
    }

    /* Flexpass */
    enableSaveFlexpassButton = (value) => {
        this.setState({
            isReadyToSubmitFlexpass: value
        });
    }

    toggleFlexpassExists = (value) => {
        this.setState({
            flexpassExists: value
        });
    }

    saveUpdateFlexpassEvent = (value) => {
        this.setState({
            saveFlexpassMode: value
        });
    }

	toggleReprintOrder = (value) => {
		this.setState({
			isReprintOrderOpen: value
		});
	}

	toggleSavePublishEvent = () => {
		this.setState({
			isSavePublishEventOpen: !this.state.isSavePublishEventOpen,
			saveEventMode: ''
		});
	}

	toggleSaveDraftEvent = () => {
		this.saveDraftEvent();
	}

	saveDraftEvent = () => {
		this.setState({
			isSavePublishEventOpen: false,
			saveEventMode: 'draft'
		});
	}

	savePublishEvent = () => {
		this.setState({
			isSavePublishEventOpen: false,
			saveEventMode: 'save'
		});
	}

	clearSaveEventMode = () => {
		this.setState({
			saveEventMode: ''
		});
	}

	toggleNav = () => {
		let isNavigationOpen = this.state.isNavigationOpen;
		isNavigationOpen = !isNavigationOpen;
		this.setState({ isNavigationOpen });
		this.setState({ isDonation: false });
	}

	toggleCart = () => {
		let isCartOpen = this.state.isCartOpen;
		isCartOpen = !isCartOpen;
		this.setState({ isCartOpen });
	}

    getTotalTicketsForHeader = async (user, payload = null) => {
        if (payload) {
			let totalItemsInCart = 0;
			payload.data.tickets.forEach((ticket) => {
				if (!ticket.social_distance) {
					totalItemsInCart++;
				}
			});
            totalItemsInCart += payload.data.flexpasses.length;
            this.setState({
                totalItemsInCart
            });
            return totalItemsInCart;
        } else {
            let query;
            user.role ? query = `/box-office/cart` : query = `/tickets/cart`;
            try {
                const cart = await ApiRequest(query);
                console.log('Get Cart Response: ', cart);
                if (cart.data.error) {
                    throw new Error('Cart Error');
                } else {
                    const totalItemsInCart = cart.data.tickets.length + cart.data.flexpasses.length;
                    this.setState({
                        totalItemsInCart
                    });
                    return totalItemsInCart;
                }
            } catch (error) {
                console.log(error);
            }
        }

    }

	getClients = async () => {
        try {
            const clientsResponse = await clients();
            //console.log('clientsResponse: ', clientsResponse);
            this.setState({ clients:clientsResponse.data.clients });
        } catch (error) {
            console.log(error);
        }

		async function clients() {
			return await ApiRequest(`/clients`);
		}
    }
    
    setGlobalCurrentClient = (client) => {
		localStorage.setItem('client', JSON.stringify(client));
        this.setState({ client });
    }

	setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

	switchUser = async (e) => {
		console.log(e);
		let client_id;
		if (!e.target) {
			client_id = e;
		} else {
			client_id = e.target.value;
		}
		console.log('switch user to ' + client_id);

        if (client_id !== "null") {
			// Get user of client id
			try {
				const response = await getClients(client_id);
				console.log('response: ', response);
				if(response.data.users.length > 0){
					let client_id;
					response.data.users.forEach((user) => {
						if(user.role === 'client') {
							client_id = user.id;
						}
					});
					if (!client_id) {
						response.data.users[0].id
					}
					try {
						const switchResponse = await switch_user(client_id);
						console.log('switchResponse: ', switchResponse);
						if(switchResponse.data.switch_user){
							this.props.history.push('/events');
                            this.setState({ 
                                isGodMode: true,
                                real_user:{...this.state.user},
                                user:switchResponse.data.switch_user 
                            });
						} else {
							this.setMessage(window.general_strings.msg.oops, switchResponse.data.error.code, 'error');
							setTimeout(() => {
								this.setMessage('', '', '');
							}, 3000);
						}
					} catch (error) {
						console.log(error);
					}
				} else {
					this.setMessage(window.general_strings.msg.oops, 'No user available.', 'error');
					setTimeout(() => {
						this.setMessage('', '', '');
					}, 3000);
				}
			} catch (error) {
				console.log(error);
			}
        }

		async function switch_user(id) {
			return await ApiRequest(`/admin/switch-user`, {
                method: 'POST',
                data: {
                    id: parseInt(id)
                }
			});
		}

		async function getClients(id) {
			return await ApiRequest(`/clients/${id}/users`, {
                method: 'GET'
			});
		}

		this.toggleNav();
    }

    emptyCartOnLogout = async () => {
        try {
            const releaseAllResponse = await releaseTickets(this.state.user);
            console.log('Release all tickets from cart: ', releaseAllResponse);
        } catch (error) {
            console.log(error);
        }

        async function releaseTickets(user) {
            console.log(user);
            let query;
            user.role ? query = `/box-office/cart` : query = `/tickets/cart`;
            return await ApiRequest(query, {
                method: 'DELETE'
            });
        }
    }
    
	logout = () => {
		localStorage.removeItem('defaultBocaPrinter');
		localStorage.removeItem('printersBoca');
		localStorage.removeItem('client');
		this.setState({
			user:{},
			isGodMode: false,
			real_user: {},
			client: {},
        });
	}

	logoutSwitchUser = async () => {
        await this.emptyCartOnLogout();

        try {
			const switchResponse = await logout_user();
			localStorage.removeItem('client');
			console.log('switchResponse: ', switchResponse);
			if(!switchResponse.data.switch_user){
				this.setState({ user:this.state.real_user }, () => {
					this.setState({ real_user:{} }, () => {
						this.setState({ isGodMode:false });
						this.props.history.push('/client/users');
					});
				});
			}
        } catch (error) {
            console.log(error);
        }

		async function logout_user() {
			return await ApiRequest(`/admin/switch-user`, {
                method: 'POST'
			});
		}

		this.toggleNav();
	}

	makeDonation = () => {
		this.setState({ 
			isDonation: true,
		});
		this.props.history.push(`/events/${this.state.client.id}`);
		setTimeout(() => {
			this.setState({
				isCartOpen: true,
			});
		}, 2000);
	}
	
	userLogin = (data, path) => {
		this.setState({ user:data.user }, () => {
			// If Call Center, get all clients to populate dropdown in Navigation
			if(data.user.role === 'admin'){
				this.getClients();
			}
			if(data.real_user) {
				this.setState({ isGodMode:true });
			}

			this.setState({
				isLoggedinUser: typeof data.user.role !== 'undefined'
			});

			if(path !== undefined){
				this.props.history.push(path);
			} else {
				if (this.state.goToDailyEmailSearch) {
					this.props.history.push(`/search?transaction_start=${this.state.transaction_start}&transaction_end=${this.state.transaction_end}`);
				} else {
					if (data.user.role !== 'admin'){
						this.props.history.push('/events');
					} else {
						this.props.history.push('/client/users');
					}
				}
			}
		});
	}
	
    startPatronTimer = async (client_id) => {
		let requestAccessResponse;
		// VIPatron retrieve token
		if (this.props.location.search && !this.state.user.role) {
			const search = this.props.location.search;
			const searchArray = search.split('=');
			requestAccessResponse = await postRequestAccess(searchArray[1], client_id);
			console.log('VIPatron Request Access Response: ', requestAccessResponse);

			async function postRequestAccess(token, client_id) {
				let query = `/tickets/request-access`;
				let data = {};
				data.token = token;
				data.client_id = client_id;
				return await ApiRequest(query, {
					method: 'POST',
					data: data,
				});
			}
		} else {
			requestAccessResponse = await postRequestAccess(this.state.user, client_id);
			console.log('Request Access Response: ', requestAccessResponse);
		}

		// Set Queue mode
		this.setState({ isQueue:requestAccessResponse.data.status === 'wait' });

        if (requestAccessResponse.data.status === 'active') {
            this.setState({ 
                timer: requestAccessResponse.data.expires
            });
			const remainingTime = moment.utc().countdown(requestAccessResponse.data.expires, countdown.MINUTES | countdown.SECONDS);
            const minutes = remainingTime.minutes.toLocaleString(undefined, { minimumIntegerDigits: 2 });
            const seconds = remainingTime.seconds.toLocaleString(undefined, { minimumIntegerDigits: 2 });

			setTimeout(() => {
				document.getElementById('message-aria').innerText = `You have ${minutes} minutes and ${seconds} seconds to complete your purchase.`;
			}, 1500);
			
        }
        localStorage.setItem('token', requestAccessResponse.data.token);
        const channel = window.Ably.channels.get(`user-waiting:${requestAccessResponse.data.token}`);
        channel.subscribe('user-ready', (message) => {
            console.log(message.data);
        });

		const ticketsInCartResponse = await this.getTotalTicketsForHeader(this.state.user);
		console.log('Total tickets for header: ', ticketsInCartResponse);

		async function postRequestAccess(user, client_id) {
            let query;
			user.role ? query = `/box-office/request-access` : query = `/tickets/request-access`;
			let data = {};
			data.client_id = client_id;
            return await ApiRequest(query, {
				method: 'POST',
				data: data,
            });
        }  
    }
    
    startClientTimer = async (cartItems) => {
        const requestClientTimer = await postClientTimer();
        console.log('Get client timer: ', requestClientTimer);

        this.setState({ 
            timer: requestClientTimer.data.expires
        });

        async function postClientTimer() {
            console.log(cartItems);
            let query = cartItems.length > 0 ? `/box-office/timer` : `/box-office/reset-timer`;
            return await ApiRequest(query, {
				method: 'POST'
            });
        } 
    }

	updateClientPreferences = () => {
		this.setState({
			isUpdateClient: true,
		});
	}

	setStreamEvent = (event, config) => {
		this.setState({
			streamEvent: event,
			streamConfig: config
		});
	}

	showStreamDescriptionModal = () => {
		this.setState({
			isNavigationOpen: false,
			isStreamDescriptionModalOpen: true
		});
	}

	hideStreamDescriptionModal = () => {
		this.setState({
			isNavigationOpen: false,
			isStreamDescriptionModalOpen: false
		});
	}

	toggleStreamDescriptionModal = () => {
		this.setState({
			isStreamDescriptionModalOpen: !this.state.isStreamDescriptionModalOpen
		});
	}

	showStreamArtistsModal = () => {
		this.setState({
			isNavigationOpen: false,
			isStreamArtistsModalOpen: true
		});
	}

	toggleStreamArtistsModal = () => {
		this.setState({
			isStreamArtistsModalOpen: !this.state.isStreamArtistsModalOpen
		});
	}

	toggleChat = () => {
        console.log("toggleChat");
		this.setState({
			isChatOpen: !this.state.isChatOpen
		});
	};

    componentDidMount() {
		// Web Socket
		window.Ably.connection.on('connected', () => {
			console.log('Web Socket connected');
		});
		window.Ably.connection.on('failed', () => {
			console.log('Web Socket failed');
		});
		window.Ably.connection.off('connected', () => {
			console.log('Web Socket off');
        });
        
        window.onbeforeunload = () => { 
            console.log("%c Thank you! Come back soon!! 🎟🍿🎬 ", "color: #fff; font-size:22px; font-weight: bold; background-color: #5c649b;");
        };

		// Get user first
		(async () => {
			try {
				const clientStatusResponse = await getAuthStatus();
                const user = clientStatusResponse.data.user || {};
                console.log('Client logged status Response: ', clientStatusResponse);

				// If user is logged in
				if(clientStatusResponse.data.authenticated){
					this.setState({ 
						user,
                        real_user: clientStatusResponse.data.real_user || user
					});
					// If Call Center, get all clients to populate dropdown in Navigation
					if(user.role === 'admin'){
						this.getClients();
					}

					if(clientStatusResponse.data.real_user) {
						this.setState({ isGodMode:true });
						this.getClients();
					}
                }
                this.setState({
					userStatusReady: true,
                    isLoggedinUser: typeof user.role !== 'undefined'
                }, () => {
					this.getIOStatus();
				});

            } catch (error) {
				console.log(error);
			}
		})()

        async function getAuthStatus() {
            return await ApiRequest('/auth/status');
		}
		
		const urlParams = new URLSearchParams(window.location.search);
        const goToDailyEmailSearch = urlParams.get('goToDailyEmailSearch') === 'yes' ? true : false;
        let transaction_start = urlParams.get('transaction_start');
		let transaction_end = urlParams.get('transaction_end');
		if (transaction_start) {
			transaction_start = transaction_start.split('T')[0];
		}
		if (transaction_end) {
			transaction_end = transaction_end.split('T')[0];
		}
        this.setState({
            goToDailyEmailSearch,
            transaction_end,
            transaction_start
        });
    }

	getIOStatus = async () => {
		let status = this.state.status;
		(async () => {
			try {
				const io_status = await axios({
					url: `https://2816333799871293.hostedstatus.com/1.0/status/609a958bbe778205396b8a83`,
					method: 'get'
				});
               
                console.log('io_status', io_status);
				status = io_status.data.result;
				this.setState({
					status,
				});
            } catch (error) {
				console.log(error);
			}
		})();
	}

	renderVersion = () => {
		const date = Date.now();
		const version = '1.0.0';
		return (
			<div className="sr-only">Build on {Intl.DateTimeFormat('en-US').format(date)} - {version}</div>
		)
	}

	render() {
		let client = localStorage.getItem('client') && localStorage.getItem('client') !== 'undefined' ? JSON.parse(localStorage.getItem('client')) : this.state.client;
		const current_client_id = localStorage.getItem('current_client_id') ? localStorage.getItem('current_client_id') : null;
		let isAdmin = this.state.real_user && this.state.real_user.role === 'admin';
		return (
			<React.Fragment>
				<a className="sr-only sr-only-focusable" href="#navigation-toggle">Skip to Navigation</a>
				<a className="sr-only sr-only-focusable" href="#main">Skip to Main content</a>
				<a className="sr-only sr-only-focusable" href="#footer">Skip to Footer</a>
				<a className="sr-only sr-only-focusable" href="#cart-main">Skip to Cart</a>
				{(process.env.REACT_APP_ENV_CONTEXT === 'development' || isAdmin) &&
                    <ClientTrackingTool
                        client={client}
                        current_client_id={current_client_id}
                        routeProps={this.props.routeProps} />
                }
				<ReprintOrder 
					isReprintOrderOpen={this.state.isReprintOrderOpen}
					toggleReprintOrder={this.toggleReprintOrder} 
					/>
				<SavePublishEvent 
					isSavePublishEventOpen={this.state.isSavePublishEventOpen}
					toggleSavePublishEvent={this.toggleSavePublishEvent} 
					saveDraftEvent={this.saveDraftEvent}
					savePublishEvent={this.savePublishEvent}
					/>
				<Header 
					toggleNav={this.toggleNav} 
                    toggleCart={this.toggleCart} 
                    totalItemsInCart={this.state.totalItemsInCart} 
					isNavigationOpen={this.state.isNavigationOpen}
					toggleSavePublishEvent={this.toggleSavePublishEvent}
					toggleSaveDraftEvent={this.toggleSaveDraftEvent}
					isEventDraftButtonHidden={this.state.isEventDraftButtonHidden}
					savePublishEvent={this.savePublishEvent}
					updateClientPreferences={this.updateClientPreferences}
					isReservedSeatingNew={this.state.isReservedSeatingNew}
					isLoggedinUser={this.state.isLoggedinUser}
					// coupon
					saveUpdateCouponEvent={this.saveUpdateCouponEvent}
					showSaveCouponBtn={this.state.showSaveCouponBtn}
					isReadyToSubmitCoupon={this.state.isReadyToSubmitCoupon}
					couponExists={this.state.couponExists}
					// flexpass
					saveUpdateFlexpassEvent={this.saveUpdateFlexpassEvent}
					isReadyToSubmitFlexpass={this.state.isReadyToSubmitFlexpass}
					flexpassExists={this.state.flexpassExists}
					// stream
					streamEvent={this.state.streamEvent}
					streamConfig={this.state.streamConfig}
					toggleChat={this.toggleChat}
				/>
				<Status
					isLoggedinUser={this.state.isLoggedinUser}
					status={this.state.status}
				/>
				<Navigation
					toggleNav={this.toggleNav}
					isNavigationOpen={this.state.isNavigationOpen}
					toggleReprintOrder={this.toggleReprintOrder} 
					user={this.state.user}
					clients={this.state.clients}
					switchUser={this.switchUser}
					logoutSwitchUser={this.logoutSwitchUser}
                    makeDonation={this.makeDonation}
                    isGodMode={this.state.isGodMode}
                    client={this.state.client}
					// stream
					streamEvent={this.state.streamEvent}
					showStreamDescriptionModal={this.showStreamDescriptionModal}
					showStreamArtistsModal={this.showStreamArtistsModal}
				/>
				<div
					className={isSafari ? 'is-safari': ''}
				>
					<div 
						className={(this.props.location.pathname === '/event' || this.props.location.pathname.includes('/create-coupon') || this.props.location.pathname.includes('/create-flexpass')) ? 'showtix-page-body showtix-page-body__header-buttons' : 'showtix-page-body'}
						onMouseDown={this.state.isNavigationOpen ? this.toggleNav : undefined}
						id="main">
						<div className="container">
							<Message
								message={this.state.message}
							/>
						</div>

						<div style={{display: 'none'}} id="message-aria" aria-live="polite">

						</div>
						{(() => {
							switch(this.state.user.role) {
								case 'client': // Client Admin
								if (this.state.real_user) {
									if (this.state.real_user.role === 'admin') {
										return (
											<Switch>
												<Route exact key="/event" path="/event" render={(routeProps) => <CreateEvent 
														clearSaveEventMode={this.clearSaveEventMode}
														saveEventMode={this.state.saveEventMode}
														routeProps={routeProps}
														toggleEventDraftButton={this.toggleEventDraftButton}
														toggleSavePublishButton={this.toggleSavePublishButton}
														user={this.state.user}
														real_user={this.state.real_user}
														/>} />
												<Route exact key="/event/:id?" path="/event/:id?" render={(routeProps) => <CreateEvent 
																clearSaveEventMode={this.clearSaveEventMode}
																saveEventMode={this.state.saveEventMode}
																routeProps={routeProps}
																toggleEventDraftButton={this.toggleEventDraftButton}
																toggleSavePublishButton={this.toggleSavePublishButton}
																user={this.state.user}
																real_user={this.state.real_user}
																/>} />
							
												<Route path="/search/:query?/:id?/:filter?" render={(routeProps) => <Search 
																		routeProps={routeProps}
																		user={this.state.user}
																		isGodMode={this.state.isGodMode}
																		/>} />
												<Route path="/checkin/:eventId/:eventDateId" component={Checkin} />
												<Route path="/create-user/:id?" render={(routeProps) => <CreateUser
																		user={this.state.user}
																		routeProps={routeProps}
																		/>} />
												<Route exact key="/create-customer" path="/create-customer" render={(routeProps) => <CreateCustomer 
																routeProps={routeProps}
																/>} />
												<Route exact key="/create-customer/:id?" path="/create-customer/:id?" render={(routeProps) => <CreateCustomer 
																routeProps={routeProps}
																/>} />
																
												<Route exact path="/client-preferences" render={(routeProps) => <ClientPreferences 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route exact key="/my-profile" path="/my-profile" render={(routeProps) => <CreateUser 
																		user={this.state.user}
																		routeProps={routeProps}
																		/>} />
												<Route exact path="/client/users" render={(routeProps) => <Users 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route exact path="/client/billing" render={(routeProps) => <Billing 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route exact path="/client/marketing" render={(routeProps) => <Marketing 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route exact path="/client/options" render={(routeProps) => <Options 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route exact path="/client/pos" render={(routeProps) => <Stripe 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route exact path="/client/star" render={(routeProps) => <Star 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route path="/coupons/" component={ManageCoupon} />
												<Route exact key="/create-coupon" path="/create-coupon" render={(routeProps) => <CreateCoupon
																		toggleSaveCouponButton={this.toggleSaveCouponButton}
																		saveUpdateCouponEvent={this.saveUpdateCouponEvent}
																		enableSaveCouponButton={this.enableSaveCouponButton}
																		toggleCouponExists={this.toggleCouponExists}
																		saveCouponMode={this.state.saveCouponMode}
																		routeProps={routeProps}
																		/>} />
												<Route exact key="/create-coupon/:id?" path="/create-coupon/:id?" render={(routeProps) => <CreateCoupon
																		toggleSaveCouponButton={this.toggleSaveCouponButton}
																		saveUpdateCouponEvent={this.saveUpdateCouponEvent}
																		enableSaveCouponButton={this.enableSaveCouponButton}
																		toggleCouponExists={this.toggleCouponExists}
																		saveCouponMode={this.state.saveCouponMode}
																		routeProps={routeProps}
																		/>} />
												<Route exact key="/create-flexpass" path="/create-flexpass" render={(routeProps) => <CreateFlexpass
																		saveUpdateFlexpassEvent={this.saveUpdateFlexpassEvent}
																		enableSaveFlexpassButton={this.enableSaveFlexpassButton}
																		toggleFlexpassExists={this.toggleFlexpassExists}
																		saveFlexpassMode={this.state.saveFlexpassMode}
																		routeProps={routeProps}
																		/>} />
												<Route exact key="/create-flexpass/:id?" path="/create-flexpass/:id?" render={(routeProps) => <CreateFlexpass
																		saveUpdateFlexpassEvent={this.saveUpdateFlexpassEvent}
																		enableSaveFlexpassButton={this.enableSaveFlexpassButton}
																		toggleFlexpassExists={this.toggleFlexpassExists}
																		saveFlexpassMode={this.state.saveFlexpassMode}
																		routeProps={routeProps}
																		/>} />
												<Route exact path="/faq" component={FAQ} />															
												<Route exact path="/terms" component={ClientAgreement} />
												<Route exact path="/claims-copyright" component={ClaimsCopyright} />
												<Route exact key="/events" path="/events" render={(routeProps) => <EventListing 
													is_client={this.state.user.is_client}
													user={this.state.user}
													real_user={this.state.real_user}
													isGodMode={this.state.isGodMode}
													isCartOpen={this.state.isCartOpen}
													routeProps={routeProps}
													timer={this.state.timer}
													isQueue={this.state.isQueue}
													isDonation={this.state.isDonation}
													getTotalTicketsForHeader={this.getTotalTicketsForHeader}
													totalItemsInCart={this.state.totalItemsInCart}
													startPatronTimer={this.startPatronTimer}
													startClientTimer={this.startClientTimer}
													setGlobalCurrentClient={this.setGlobalCurrentClient}
													client={this.state.client}
													makeDonation={this.makeDonation}
													
												/>} />
												<Route exact key="/events/:id?" path="/events/:id?" render={(routeProps) => <Forbidden user={this.state.user} />} />
												<Route exact key="/event-details/:id?" path="/event-details/:id?" render={(routeProps) => <EventLanding
													user={this.state.user}
													routeProps={routeProps}
													isDonation={this.state.isDonation}
													client={this.state.client}
													makeDonation={this.makeDonation}
													setGlobalCurrentClient={this.setGlobalCurrentClient}
												/>} />
												<Route exact path="/signup" render={(routeProps) => <Registration
																									userLogin={this.userLogin}
																									routeProps={routeProps}
																								/>} />
												<Route path="/login/:userid?/:username?" render={(routeProps) => <Login
																													userLogin={this.userLogin}
																													routeProps={routeProps}
																													emptyCartOnLogout={this.emptyCartOnLogout}
																													user={this.state.user}
																													userStatusReady={this.state.userStatusReady}
																												/>} />
												<Route path="/logout" render={(routeProps) => <Login
																									userLogin={this.userLogin}
																									logout={this.logout}
																									routeProps={routeProps}
																									emptyCartOnLogout={this.emptyCartOnLogout}
																									user={this.state.user}
																									userStatusReady={this.state.userStatusReady}
																								/>} />
												<Route path="/reset-password/:token?" render={(routeProps) => <ResetPassword
																													userLogin={this.userLogin}
																													routeProps={routeProps}
																												/>} />
												<Route path="/new-user-login/:token?" render={(routeProps) => <NewUserLogin
																									userLogin={this.userLogin}
																									routeProps={routeProps}
																								/>} />
												<Route exact path="/forgot-username" component={ForgotUsername} />
												<Route exact path="/forgot-password" component={ForgotPassword} />
												<Route exact path="/user-agreement" component={UserAgreement} />
												<Route exact path="/privacy-policy" component={PrivacyPolicy} />
												<Route exact path="/customer-tickets" render={(routeProps) => <TicketDownload
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
												<Route exact path="/onboarding/complete" render={(routeProps) => <OnboardComplete
																		user={this.state.user}
																		routeProps={routeProps}
																		/>} />
												<Route exact key="/stream/:id?" path="/stream/:id?" render={(routeProps) => <Stream
													user={this.state.user}
													setStreamEvent={this.setStreamEvent}
													isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
													toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
													hideStreamDescriptionModal={this.hideStreamDescriptionModal}
													isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
													toggleStreamArtistsModal={this.toggleStreamArtistsModal}
													isChatOpen={this.state.isChatOpen}
													toggleChat={this.toggleChat}
													routeProps={routeProps}
												/>} />
												<Route exact path="/launch" render={(routeProps) =>
													<StreamLaunch
														routeProps={routeProps}
													/>
												} />
												<Route exact path="/demo" render={(routeProps) =>
													<StreamDemo
														setStreamEvent={this.setStreamEvent}
														isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
														toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
														hideStreamDescriptionModal={this.hideStreamDescriptionModal}
														isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
														toggleStreamArtistsModal={this.toggleStreamArtistsModal}
														routeProps={routeProps}
													/>
												} />
												<Route exact path="/updates" render={(routeProps) =>
													<StreamUpdates
														setStreamEvent={this.setStreamEvent}
														isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
														toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
														hideStreamDescriptionModal={this.hideStreamDescriptionModal}
														isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
														toggleStreamArtistsModal={this.toggleStreamArtistsModal}
														routeProps={routeProps}
													/>
                                                } />
												<Route exact path="/upload/:event_id" render={(routeProps) => <Upload
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
												<Route exact path="/upload" render={(routeProps) => <Forbidden user={this.state.user} />} />
												<Route exact path="/payout" render={(routeProps) => <Payout
													routeProps={routeProps}
													user={this.state.user}
												/>} />
												<Route exact path="/accessibility" component={Accessibility} />
												<Route exact path="/account-balance" render={(routeProps) => <AccountBalance
													routeProps={routeProps}
													user={this.state.user}
												/>} />
												<Route exact path="/electronic-ticket/:token/:ticketId?" render={(routeProps) => <ElectronicTicket
																									routeProps={routeProps}
																								/>} />
												<Route exact path="/ticket-distribution" render={(routeProps) => <TicketDistribution
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
												<Route exact path="/get-token" render={(routeProps) => <GetToken
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
												<Route exact path="/unsubscribe" render={(routeProps) => <Unsubscribe
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
												<Route component={Page404} />
											</Switch>
										)
									} else {
										return (
											<Switch>
												<Route exact key="/event" path="/event" render={(routeProps) => <CreateEvent 
																clearSaveEventMode={this.clearSaveEventMode}
																saveEventMode={this.state.saveEventMode}
																routeProps={routeProps}
																toggleEventDraftButton={this.toggleEventDraftButton}
																toggleSavePublishButton={this.toggleSavePublishButton}
																user={this.state.user}
																real_user={this.state.real_user}
																/>} />
												<Route exact key="/event/:id?" path="/event/:id?" render={(routeProps) => <CreateEvent 
																clearSaveEventMode={this.clearSaveEventMode}
																saveEventMode={this.state.saveEventMode}
																routeProps={routeProps}
																toggleEventDraftButton={this.toggleEventDraftButton}
																toggleSavePublishButton={this.toggleSavePublishButton}
																user={this.state.user}
																real_user={this.state.real_user}
																/>} />
							
												<Route path="/search/:query?/:id?/:filter?" render={(routeProps) => <Search 
																		routeProps={routeProps}
																		user={this.state.user}
																		isGodMode={this.state.isGodMode}
																		/>} />
												<Route path="/checkin/:eventId/:eventDateId" component={Checkin} />
												<Route path="/create-user/:id?" render={(routeProps) => <CreateUser
																		user={this.state.user}
																		routeProps={routeProps}
																		/>} />
												<Route exact key="/create-customer" path="/create-customer" render={(routeProps) => <CreateCustomer 
																routeProps={routeProps}
																/>} />
												<Route exact key="/create-customer/:id?" path="/create-customer/:id?" render={(routeProps) => <CreateCustomer 
																routeProps={routeProps}
																/>} />
																
												<Route exact path="/client-preferences" render={(routeProps) => <ClientPreferences 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route exact key="/my-profile" path="/my-profile" render={(routeProps) => <CreateUser 
																		user={this.state.user}
																		routeProps={routeProps}
																		/>} />
												<Route exact path="/client/users" render={(routeProps) => <Users 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route exact path="/client/billing" render={(routeProps) => <Billing 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route exact path="/client/marketing" render={(routeProps) => <Marketing 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route exact path="/client/options" render={(routeProps) => <Options 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route exact path="/client/pos" render={(routeProps) => <Stripe 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route exact path="/client/star" render={(routeProps) => <Star 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
												<Route path="/coupons/" component={ManageCoupon} />
												<Route exact key="/create-coupon" path="/create-coupon" render={(routeProps) => <CreateCoupon
																		toggleSaveCouponButton={this.toggleSaveCouponButton}
																		saveUpdateCouponEvent={this.saveUpdateCouponEvent}
																		enableSaveCouponButton={this.enableSaveCouponButton}
																		toggleCouponExists={this.toggleCouponExists}
																		saveCouponMode={this.state.saveCouponMode}
																		routeProps={routeProps}
																		/>} />
												<Route exact key="/create-coupon/:id?" path="/create-coupon/:id?" render={(routeProps) => <CreateCoupon
																		toggleSaveCouponButton={this.toggleSaveCouponButton}
																		saveUpdateCouponEvent={this.saveUpdateCouponEvent}
																		enableSaveCouponButton={this.enableSaveCouponButton}
																		toggleCouponExists={this.toggleCouponExists}
																		saveCouponMode={this.state.saveCouponMode}
																		routeProps={routeProps}
																		/>} />
												<Route exact key="/create-flexpass" path="/create-flexpass" render={(routeProps) => <CreateFlexpass
																		saveUpdateFlexpassEvent={this.saveUpdateFlexpassEvent}
																		enableSaveFlexpassButton={this.enableSaveFlexpassButton}
																		toggleFlexpassExists={this.toggleFlexpassExists}
																		saveFlexpassMode={this.state.saveFlexpassMode}
																		routeProps={routeProps}
																		/>} />
												<Route exact key="/create-flexpass/:id?" path="/create-flexpass/:id?" render={(routeProps) => <CreateFlexpass
																		saveUpdateFlexpassEvent={this.saveUpdateFlexpassEvent}
																		enableSaveFlexpassButton={this.enableSaveFlexpassButton}
																		toggleFlexpassExists={this.toggleFlexpassExists}
																		saveFlexpassMode={this.state.saveFlexpassMode}
																		routeProps={routeProps}
																		/>} />
												<Route exact path="/faq" component={FAQ} />															
												<Route exact path="/terms" component={ClientAgreement} />
												<Route exact path="/claims-copyright" component={ClaimsCopyright} />
												<Route exact key="/events" path="/events" render={(routeProps) => <EventListing 
													is_client={this.state.user.is_client}
													user={this.state.user}
													real_user={this.state.real_user}
													isGodMode={this.state.isGodMode}
													isCartOpen={this.state.isCartOpen}
													routeProps={routeProps}
													timer={this.state.timer}
													isQueue={this.state.isQueue}
													isDonation={this.state.isDonation}
													getTotalTicketsForHeader={this.getTotalTicketsForHeader}
													totalItemsInCart={this.state.totalItemsInCart}
													startPatronTimer={this.startPatronTimer}
													startClientTimer={this.startClientTimer}
													setGlobalCurrentClient={this.setGlobalCurrentClient}
													client={this.state.client}
													makeDonation={this.makeDonation}
													
												/>} />
												<Route exact key="/events/:id?" path="/events/:id?" render={(routeProps) => <Forbidden user={this.state.user} />} />
												<Route exact key="/event-details/:id?" path="/event-details/:id?" render={(routeProps) => <EventLanding
													user={this.state.user}
													routeProps={routeProps}
													isDonation={this.state.isDonation}
													client={this.state.client}
													makeDonation={this.makeDonation}
													setGlobalCurrentClient={this.setGlobalCurrentClient}
												/>} />
												<Route exact path="/signup" render={(routeProps) => <Registration
																									userLogin={this.userLogin}
																									routeProps={routeProps}
																								/>} />
												<Route path="/login/:userid?/:username?" render={(routeProps) => <Login
																													userLogin={this.userLogin}
																													routeProps={routeProps}
																													emptyCartOnLogout={this.emptyCartOnLogout}
																													user={this.state.user}
																													userStatusReady={this.state.userStatusReady}
																												/>} />
												<Route path="/logout" render={(routeProps) => <Login
																									userLogin={this.userLogin}
																									logout={this.logout}
																									routeProps={routeProps}
																									emptyCartOnLogout={this.emptyCartOnLogout}
																									user={this.state.user}
																									userStatusReady={this.state.userStatusReady}
																								/>} />
												<Route path="/reset-password/:token?" render={(routeProps) => <ResetPassword
																													userLogin={this.userLogin}
																													routeProps={routeProps}
																												/>} />
												<Route path="/new-user-login/:token?" render={(routeProps) => <NewUserLogin
																									userLogin={this.userLogin}
																									routeProps={routeProps}
																								/>} />
												<Route exact path="/forgot-username" component={ForgotUsername} />
												<Route exact path="/forgot-password" component={ForgotPassword} />
												<Route exact path="/user-agreement" component={UserAgreement} />
												<Route exact path="/privacy-policy" component={PrivacyPolicy} />
												<Route exact path="/customer-tickets" render={(routeProps) => <TicketDownload
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
												<Route exact path="/onboarding/complete" render={(routeProps) => <OnboardComplete
																		user={this.state.user}
																		routeProps={routeProps}
																		/>} />
												<Route exact key="/stream/:id?" path="/stream/:id?" render={(routeProps) => <Stream
													user={this.state.user}
													setStreamEvent={this.setStreamEvent}
													isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
													toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
													hideStreamDescriptionModal={this.hideStreamDescriptionModal}
													isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
													toggleStreamArtistsModal={this.toggleStreamArtistsModal}
													isChatOpen={this.state.isChatOpen}
													toggleChat={this.toggleChat}
													routeProps={routeProps}
												/>} />
												<Route exact path="/launch" render={(routeProps) =>
													<StreamLaunch
														routeProps={routeProps}
													/>
												} />
												<Route exact path="/demo" render={(routeProps) =>
													<StreamDemo
														setStreamEvent={this.setStreamEvent}
														isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
														toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
														hideStreamDescriptionModal={this.hideStreamDescriptionModal}
														isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
														toggleStreamArtistsModal={this.toggleStreamArtistsModal}
														routeProps={routeProps}
													/>
												} />
												<Route exact path="/updates" render={(routeProps) =>
													<StreamUpdates
														setStreamEvent={this.setStreamEvent}
														isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
														toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
														hideStreamDescriptionModal={this.hideStreamDescriptionModal}
														isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
														toggleStreamArtistsModal={this.toggleStreamArtistsModal}
														routeProps={routeProps}
													/>
                                                } />
												<Route exact path="/upload/:event_id" render={(routeProps) => <Upload
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
												<Route exact path="/upload" render={(routeProps) => <Forbidden user={this.state.user} />} />
												<Route exact path="/accessibility" component={Accessibility} />
												<Route exact path="/account-balance" render={(routeProps) => <AccountBalance
													routeProps={routeProps}
													user={this.state.user}
												/>} />
												<Route exact path="/electronic-ticket/:token/:ticketId?" render={(routeProps) => <ElectronicTicket
																									routeProps={routeProps}
																								/>} />
												<Route exact path="/ticket-distribution" render={(routeProps) => <TicketDistribution
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
												<Route exact path="/get-token" render={(routeProps) => <GetToken
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
												<Route exact path="/unsubscribe" render={(routeProps) => <Unsubscribe
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
												<Route component={Page404} />
											</Switch>	
										);
									}
								}
								break;
					
								case 'box-office': // Client Box Office
								return (
									<Switch>
										<Route path="/search/:query?/:id?/:filter?" render={(routeProps) => <Search 
																routeProps={routeProps}
																user={this.state.user}
																isGodMode={this.state.isGodMode}
																/>} />
										<Route path="/checkin/:eventId/:eventDateId" component={Checkin} />
										<Route exact key="/create-customer" path="/create-customer" render={(routeProps) => <CreateCustomer 
														routeProps={routeProps}
														/>} />
										<Route exact key="/create-customer/:id?" path="/create-customer/:id?" render={(routeProps) => <CreateCustomer 
														routeProps={routeProps}
														/>} />
										<Route exact key="/my-profile" path="/my-profile" render={(routeProps) => <CreateUser 
																user={this.state.user}
																routeProps={routeProps}
																/>} />
										<Route exact path="/faq" component={FAQ} />															
										<Route exact key="/events" path="/events" render={(routeProps) => <EventListing 
                                            is_client={this.state.user.is_client}
                                            user={this.state.user}
											real_user={this.state.real_user}
                                            isGodMode={this.state.isGodMode}
                                            isCartOpen={this.state.isCartOpen}
                                            routeProps={routeProps}
											timer={this.state.timer}
											isDonation={this.state.isDonation}
                                            getTotalTicketsForHeader={this.getTotalTicketsForHeader}
											totalItemsInCart={this.state.totalItemsInCart}
                                            startPatronTimer={this.startPatronTimer}
                                            startClientTimer={this.startClientTimer}
                                            setGlobalCurrentClient={this.setGlobalCurrentClient}
											makeDonation={this.makeDonation}
											client={this.state.client}
											
                                        />} />
                                        <Route exact key="/events/:id?" path="/events/:id?" render={(routeProps) => <Forbidden user={this.state.user} />} />
										<Route exact key="/event-details/:id?" path="/event-details/:id?" render={(routeProps) => <EventLanding
                                            user={this.state.user}
											routeProps={routeProps}
											isDonation={this.state.isDonation}
											client={this.state.client}
											makeDonation={this.makeDonation}
											setGlobalCurrentClient={this.setGlobalCurrentClient}
										/>} />
										<Route exact path="/signup" render={(routeProps) => <Registration
																							userLogin={this.userLogin}
																							routeProps={routeProps}
																						/>} />
										<Route path="/login/:userid?/:username?" render={(routeProps) => <Login
																											userLogin={this.userLogin}
                                                                                                            routeProps={routeProps}
                                                                                                            emptyCartOnLogout={this.emptyCartOnLogout}
                                                                                                            user={this.state.user}
                                                                                                            userStatusReady={this.state.userStatusReady}
																										/>} />
										<Route path="/logout" render={(routeProps) => <Login
																							logout={this.logout}
																							userLogin={this.userLogin}
                                                                                            routeProps={routeProps}
                                                                                            emptyCartOnLogout={this.emptyCartOnLogout}
                                                                                            user={this.state.user}
                                                                                            userStatusReady={this.state.userStatusReady}
																						/>} />
										<Route path="/reset-password/:token?" render={(routeProps) => <ResetPassword
																											userLogin={this.userLogin}
																											routeProps={routeProps}
																										/>} />
                                        <Route path="/new-user-login/:token?" render={(routeProps) => <NewUserLogin
																							userLogin={this.userLogin}
																							routeProps={routeProps}
																						/>} />
										<Route exact path="/forgot-username" component={ForgotUsername} />
										<Route exact path="/forgot-password" component={ForgotPassword} />
										<Route exact path="/user-agreement" component={UserAgreement} />
										<Route exact path="/privacy-policy" component={PrivacyPolicy} />
										<Route exact path="/customer-tickets" render={(routeProps) => <TicketDownload
																							routeProps={routeProps}
																							user={this.state.user}
																						/>} />
										<Route exact path="/onboarding/complete" render={(routeProps) => <OnboardComplete
																user={this.state.user}
																routeProps={routeProps}
																/>} />
										<Route exact key="/stream/:id?" path="/stream/:id?" render={(routeProps) => <Stream
											user={this.state.user}
											setStreamEvent={this.setStreamEvent}
											isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
											toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
											hideStreamDescriptionModal={this.hideStreamDescriptionModal}
											isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
											toggleStreamArtistsModal={this.toggleStreamArtistsModal}
											isChatOpen={this.state.isChatOpen}
											toggleChat={this.toggleChat}
											routeProps={routeProps}
										/>} />
										<Route exact path="/launch" render={(routeProps) =>
											<StreamLaunch
												routeProps={routeProps}
											/>
										} />
										<Route exact path="/demo" render={(routeProps) =>
											<StreamDemo
												setStreamEvent={this.setStreamEvent}
												isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
												toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
												hideStreamDescriptionModal={this.hideStreamDescriptionModal}
												isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
												toggleStreamArtistsModal={this.toggleStreamArtistsModal}
												routeProps={routeProps}
											/>
										} />
										<Route exact path="/updates" render={(routeProps) =>
											<StreamUpdates
												setStreamEvent={this.setStreamEvent}
												isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
												toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
												hideStreamDescriptionModal={this.hideStreamDescriptionModal}
												isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
												toggleStreamArtistsModal={this.toggleStreamArtistsModal}
												routeProps={routeProps}
											/>
                                        } />
										<Route exact path="/upload/:event_id" render={(routeProps) => <Upload
																							routeProps={routeProps}
																							user={this.state.user}
																						/>} />
										<Route exact path="/upload" render={(routeProps) => <Forbidden user={this.state.user} />} />
										<Route exact path="/accessibility" component={Accessibility} />
										<Route exact path="/account-balance" render={(routeProps) => <AccountBalance
											routeProps={routeProps}
											user={this.state.user}
										/>} />
										<Route exact path="/electronic-ticket/:token/:ticketId?" render={(routeProps) => <ElectronicTicket
																									routeProps={routeProps}
																								/>} />
										<Route exact path="/ticket-distribution" render={(routeProps) => <TicketDistribution
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
										<Route exact path="/get-token" render={(routeProps) => <GetToken
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
										<Route exact path="/unsubscribe" render={(routeProps) => <Unsubscribe
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
										<Route component={Page404} />
									</Switch>
								)
								break;
					
								case 'admin': // Call Center
								return (
									<Switch>
										<Route exact key="/event" path="/event" render={(routeProps) => <CreateEvent 
														clearSaveEventMode={this.clearSaveEventMode}
														saveEventMode={this.state.saveEventMode}
														routeProps={routeProps}
														toggleEventDraftButton={this.toggleEventDraftButton}
														toggleSavePublishButton={this.toggleSavePublishButton}
														user={this.state.user}
														real_user={this.state.real_user}
														/>} />
										<Route exact key="/event/:id?" path="/event/:id?" render={(routeProps) => <CreateEvent 
														clearSaveEventMode={this.clearSaveEventMode}
														saveEventMode={this.state.saveEventMode}
														routeProps={routeProps}
														toggleEventDraftButton={this.toggleEventDraftButton}
														toggleSavePublishButton={this.toggleSavePublishButton}
														user={this.state.user}
														real_user={this.state.real_user}
														/>} />
					
										<Route path="/search/:query?/:id?/:filter?" render={(routeProps) => <Search 
																routeProps={routeProps}
																user={this.state.user}
																isGodMode={this.state.isGodMode}
																/>} />
										<Route path="/search-events" render={(routeProps) => <SearchEvents 
																routeProps={routeProps}
																user={this.state.user}
																switchUser={this.switchUser}
																/>} />
										<Route path="/checkin/:eventId/:eventDateId" component={Checkin} />
										<Route path="/create-user/:id?" render={(routeProps) => <CreateUser
																user={this.state.user}
																routeProps={routeProps}
																/>} />
										<Route exact key="/create-customer" path="/create-customer" render={(routeProps) => <CreateCustomer 
														routeProps={routeProps}
														/>} />
										<Route exact key="/create-customer/:id?" path="/create-customer/:id?" render={(routeProps) => <CreateCustomer 
														routeProps={routeProps}
														/>} />
										<Route exact path="/client-preferences" render={(routeProps) => <ClientPreferences
																user={this.state.user}
																isUpdateClient={this.state.isUpdateClient}
																/>} />
                                        <Route exact key="/my-profile" path="/my-profile" render={(routeProps) => <CreateUser 
																user={this.state.user}
																routeProps={routeProps}
																/>} />
										<Route exact path="/client/users" render={(routeProps) => <Users 
																isUpdateClient={this.state.isUpdateClient}
																user={this.state.user}
																/>} />
										<Route exact path="/client/billing" render={(routeProps) => <Billing 
																isUpdateClient={this.state.isUpdateClient}
																user={this.state.user}
																/>} />
										<Route exact path="/client/marketing" render={(routeProps) => <Marketing 
																isUpdateClient={this.state.isUpdateClient}
																user={this.state.user}
																/>} />
										<Route exact path="/client/options" render={(routeProps) => <Options 
																isUpdateClient={this.state.isUpdateClient}
																user={this.state.user}
																/>} />
										<Route exact path="/client/pos" render={(routeProps) => <Stripe 
																isUpdateClient={this.state.isUpdateClient}
																user={this.state.user}
																/>} />
										<Route exact path="/client/star" render={(routeProps) => <Star 
																		isUpdateClient={this.state.isUpdateClient}
																		user={this.state.user}
																		/>} />
										<Route path="/coupons/" component={ManageCoupon} />
										<Route exact key="/create-coupon" path="/create-coupon" render={(routeProps) => <CreateCoupon
																toggleSaveCouponButton={this.toggleSaveCouponButton}
																saveUpdateCouponEvent={this.saveUpdateCouponEvent}
																enableSaveCouponButton={this.enableSaveCouponButton}
																toggleCouponExists={this.toggleCouponExists}
																saveCouponMode={this.state.saveCouponMode}
																routeProps={routeProps}
																/>} />
										<Route exact key="/create-coupon/:id?" path="/create-coupon/:id?" render={(routeProps) => <CreateCoupon
																toggleSaveCouponButton={this.toggleSaveCouponButton}
																saveUpdateCouponEvent={this.saveUpdateCouponEvent}
																enableSaveCouponButton={this.enableSaveCouponButton}
																toggleCouponExists={this.toggleCouponExists}
																saveCouponMode={this.state.saveCouponMode}
																routeProps={routeProps}
																/>} />
										<Route exact key="/create-flexpass" path="/create-flexpass" render={(routeProps) => <CreateFlexpass
																saveUpdateFlexpassEvent={this.saveUpdateFlexpassEvent}
																enableSaveFlexpassButton={this.enableSaveFlexpassButton}
																toggleFlexpassExists={this.toggleFlexpassExists}
																saveFlexpassMode={this.state.saveFlexpassMode}
																routeProps={routeProps}
																/>} />
										<Route exact key="/create-flexpass/:id?" path="/create-flexpass/:id?" render={(routeProps) => <CreateFlexpass
																saveUpdateFlexpassEvent={this.saveUpdateFlexpassEvent}
																enableSaveFlexpassButton={this.enableSaveFlexpassButton}
																toggleFlexpassExists={this.toggleFlexpassExists}
																saveFlexpassMode={this.state.saveFlexpassMode}
																routeProps={routeProps}
																/>} />
										<Route exact path="/faq" component={FAQ} />															
										<Route exact path="/terms" component={ClientAgreement} />
										<Route exact path="/claims-copyright" component={ClaimsCopyright} />
										<Route exact key="/events" path="/events" render={(routeProps) => <EventListing 
                                            is_client={this.state.user.is_client}
                                            user={this.state.user}
											real_user={this.state.real_user}
                                            isGodMode={this.state.isGodMode}
                                            isCartOpen={this.state.isCartOpen}
                                            routeProps={routeProps}
											timer={this.state.timer}
											isDonation={this.state.isDonation}
                                            getTotalTicketsForHeader={this.getTotalTicketsForHeader}
											totalItemsInCart={this.state.totalItemsInCart}
                                            startPatronTimer={this.startPatronTimer}
                                            startClientTimer={this.startClientTimer}
                                            setGlobalCurrentClient={this.setGlobalCurrentClient}
											makeDonation={this.makeDonation}
											client={this.state.client}
											
                                        />} />
                                        <Route exact key="/events/:id?" path="/events/:id?" render={(routeProps) => <Forbidden user={this.state.user} />} />
										<Route exact key="/event-details/:id?" path="/event-details/:id?" render={(routeProps) => <EventLanding
                                            user={this.state.user}
											routeProps={routeProps}
											isDonation={this.state.isDonation}
											client={this.state.client}
											makeDonation={this.makeDonation}
											setGlobalCurrentClient={this.setGlobalCurrentClient}
										/>} />
										<Route exact path="/signup" render={(routeProps) => <Registration
																							userLogin={this.userLogin}
																							routeProps={routeProps}
																						/>} />
										<Route path="/login/:userid?/:username?" render={(routeProps) => <Login
																											userLogin={this.userLogin}
                                                                                                            routeProps={routeProps}
                                                                                                            emptyCartOnLogout={this.emptyCartOnLogout}
                                                                                                            user={this.state.user}
                                                                                                            userStatusReady={this.state.userStatusReady}
																										/>} />
										<Route path="/logout" render={(routeProps) => <Login
																							userLogin={this.userLogin}
																							logout={this.logout}
                                                                                            routeProps={routeProps}
                                                                                            emptyCartOnLogout={this.emptyCartOnLogout}
                                                                                            user={this.state.user}
                                                                                            userStatusReady={this.state.userStatusReady}    
																						/>} />
										<Route path="/reset-password/:token?" render={(routeProps) => <ResetPassword
																											userLogin={this.userLogin}
																											routeProps={routeProps}
																										/>} />
                                        <Route path="/new-user-login/:token?" render={(routeProps) => <NewUserLogin
																							userLogin={this.userLogin}
																							routeProps={routeProps}
																						/>} />
										<Route exact path="/forgot-username" component={ForgotUsername} />
										<Route exact path="/forgot-password" component={ForgotPassword} />
										<Route exact path="/user-agreement" component={UserAgreement} />
										<Route exact path="/privacy-policy" component={PrivacyPolicy} />
										<Route exact path="/customer-tickets" render={(routeProps) => <TicketDownload
																							routeProps={routeProps}
																							user={this.state.user}
																						/>} />
										<Route exact path="/videos" component={Videos} />
										<Route exact path="/onboarding/complete" render={(routeProps) => <OnboardComplete
																user={this.state.user}
																routeProps={routeProps}
																/>} />
										<Route exact key="/stream/:id?" path="/stream/:id?" render={(routeProps) => <Stream
											user={this.state.user}
											setStreamEvent={this.setStreamEvent}
											isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
											toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
											hideStreamDescriptionModal={this.hideStreamDescriptionModal}
											isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
											toggleStreamArtistsModal={this.toggleStreamArtistsModal}
											isChatOpen={this.state.isChatOpen}
											toggleChat={this.toggleChat}
											routeProps={routeProps}
										/>} />
										<Route exact path="/launch" render={(routeProps) =>
											<StreamLaunch
												routeProps={routeProps}
											/>
										} />
										<Route exact path="/demo" render={(routeProps) =>
											<StreamDemo
												setStreamEvent={this.setStreamEvent}
												isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
												toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
												hideStreamDescriptionModal={this.hideStreamDescriptionModal}
												isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
												toggleStreamArtistsModal={this.toggleStreamArtistsModal}
												routeProps={routeProps}
											/>
										} />
										<Route exact path="/updates" render={(routeProps) =>
											<StreamUpdates
												setStreamEvent={this.setStreamEvent}
												isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
												toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
												hideStreamDescriptionModal={this.hideStreamDescriptionModal}
												isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
												toggleStreamArtistsModal={this.toggleStreamArtistsModal}
												routeProps={routeProps}
											/>
                                        } />
										<Route exact path="/upload/:event_id" render={(routeProps) => <Upload
																							user={this.state.user}
																							routeProps={routeProps}
																						/>} />
										<Route exact path="/upload" render={(routeProps) => <Forbidden user={this.state.user} />} />
										<Route exact path="/payout" render={(routeProps) => <Payout
																							routeProps={routeProps}
																							user={this.state.user}
																						/>} />
										<Route exact path="/accessibility" component={Accessibility} />
										<Route exact path="/account-balance" render={(routeProps) => <AccountBalance
											routeProps={routeProps}
											user={this.state.user}
										/>} />
												<Route exact path="/electronic-ticket/:token/:ticketId?" render={(routeProps) => <ElectronicTicket
																									routeProps={routeProps}
																								/>} />
										<Route exact path="/ticket-distribution" render={(routeProps) => <TicketDistribution
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
										<Route exact path="/get-token" render={(routeProps) => <GetToken
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
										<Route exact path="/unsubscribe" render={(routeProps) => <Unsubscribe
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
										<Route component={Page404} />
									</Switch>	
								)
								break;
									
								default:
								return (
									<Switch>
                                        <Route exact key="/events" path="/events" render={(routeProps) => <Forbidden user={this.state.user} />} />
										<Route exact key="/events/:id?" path="/events/:id?" render={(routeProps) => <EventListing 
                                            is_client={this.state.user.is_client}
                                            user={this.state.user}
											real_user={this.state.real_user}
                                            isGodMode={this.state.isGodMode}
                                            isCartOpen={this.state.isCartOpen}
											routeProps={routeProps}
											isQueue={this.state.isQueue}
											timer={this.state.timer}
											isDonation={this.state.isDonation}
                                            getTotalTicketsForHeader={this.getTotalTicketsForHeader}
											totalItemsInCart={this.state.totalItemsInCart}
                                            startPatronTimer={this.startPatronTimer}
                                            startClientTimer={this.startClientTimer}
                                            setGlobalCurrentClient={this.setGlobalCurrentClient}
											makeDonation={this.makeDonation}
											client={this.state.client}
											
                                        />} />
										<Route exact key="/event-details/:id?" path="/event-details/:id?" render={(routeProps) => <EventLanding
											routeProps={routeProps}
                                            user={this.state.user}
											isDonation={this.state.isDonation}
											client={this.state.client}
											makeDonation={this.makeDonation}
											setGlobalCurrentClient={this.setGlobalCurrentClient}
										/>} />
										<Route exact path="/signup" render={(routeProps) => <Registration
																							userLogin={this.userLogin}
																							routeProps={routeProps}
																						/>} />
										<Route path="/login/:userid?/:username?" render={(routeProps) => <Login
																						    userLogin={this.userLogin}
                                                                                            routeProps={routeProps}
                                                                                            emptyCartOnLogout={this.emptyCartOnLogout}
                                                                                            user={this.state.user}
                                                                                            userStatusReady={this.state.userStatusReady}
																						/>} />
										<Route exact path="/terms" component={ClientAgreement} />
										<Route exact path="/claims-copyright" component={ClaimsCopyright} />
										<Route exact path="/user-agreement" component={UserAgreement} />
										<Route path="/reset-password/:token?" render={(routeProps) => <ResetPassword
																											userLogin={this.userLogin}
																											routeProps={routeProps}
																										/>} />
                                        <Route path="/new-user-login/:token?" render={(routeProps) => <NewUserLogin
																							userLogin={this.userLogin}
																							routeProps={routeProps}
																						/>} />
										<Route path="/logout" render={(routeProps) => <Login
																		userLogin={this.userLogin}
																		logout={this.logout}
                                                                        routeProps={routeProps}
                                                                        emptyCartOnLogout={this.emptyCartOnLogout}
                                                                        user={this.state.user}
                                                                        userStatusReady={this.state.userStatusReady}
																	/>} />
										<Route exact path="/forgot-username" component={ForgotUsername} />
										<Route exact path="/forgot-password" component={ForgotPassword} />
										<Route exact path="/user-agreement" component={UserAgreement} />
										<Route exact path="/privacy-policy" component={PrivacyPolicy} />
										<Route exact path="/customer-tickets" render={(routeProps) => <TicketDownload
																							routeProps={routeProps}
																							user={this.state.user}
																						/>} />
										<Route exact key="/stream/:id?" path="/stream/:id?" render={(routeProps) => <Stream
											user={this.state.user}
											setStreamEvent={this.setStreamEvent}
											isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
											toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
											hideStreamDescriptionModal={this.hideStreamDescriptionModal}
											isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
											toggleStreamArtistsModal={this.toggleStreamArtistsModal}
											isChatOpen={this.state.isChatOpen}
											toggleChat={this.toggleChat}
											routeProps={routeProps}
										/>} />
										<Route exact path="/launch" render={(routeProps) =>
											<StreamLaunch
												routeProps={routeProps}
											/>
										} />
										<Route exact path="/demo" render={(routeProps) =>
											<StreamDemo
												setStreamEvent={this.setStreamEvent}
												isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
												toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
												hideStreamDescriptionModal={this.hideStreamDescriptionModal}
												isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
												toggleStreamArtistsModal={this.toggleStreamArtistsModal}
												routeProps={routeProps}
											/>
										} />
										<Route exact path="/updates" render={(routeProps) =>
											<StreamUpdates
												setStreamEvent={this.setStreamEvent}
												isStreamDescriptionModalOpen={this.state.isStreamDescriptionModalOpen}
												toggleStreamDescriptionModal={this.toggleStreamDescriptionModal}
												hideStreamDescriptionModal={this.hideStreamDescriptionModal}
												isStreamArtistsModalOpen={this.state.isStreamArtistsModalOpen}
												toggleStreamArtistsModal={this.toggleStreamArtistsModal}
												routeProps={routeProps}
											/>
                                        } />
										<Route exact path="/upload/:event_id" render={(routeProps) => <Forbidden user={this.state.user} />} />
										<Route exact path="/upload" render={(routeProps) => <Upload
																							user={this.state.user}
																							routeProps={routeProps}
																						/>} />
										<Route exact path="/onboarding/complete" render={(routeProps) => <OnboardComplete
																		user={this.state.user}
																		routeProps={routeProps}
																		/>} />
										<Route exact path="/accessibility" component={Accessibility} />
										<Route exact path="/account-balance" render={(routeProps) => <AccountBalance
											routeProps={routeProps}
											user={this.state.user}
										/>} />
												<Route exact path="/electronic-ticket/:token/:ticketId?" render={(routeProps) => <ElectronicTicket
																									routeProps={routeProps}
																								/>} />
										<Route exact path="/ticket-distribution" render={(routeProps) => <TicketDistribution
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
										<Route exact path="/get-token" render={(routeProps) => <GetToken
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
										<Route exact path="/unsubscribe" render={(routeProps) => <Unsubscribe
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
										<Route exact path="/stripe-payment" render={(routeProps) => <StripePayment
																									routeProps={routeProps}
																									user={this.state.user}
																								/>} />
										<Route component={Page404} />
									</Switch>
								)
								break;
							}
						})()}
						
						<Footer />
					</div>
				</div>
				{this.renderVersion()}
            </React.Fragment>
		);
	}
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js